import React from "react";
import cn from "classnames";
import useIsFavorited from "storefront/hooks/useIsFavorited";
import { From } from "storefront/Analytics/EventCreators/productAddedToWishlist";
import { AlgoliaInstantSearchListing } from "storefront/components/FiltersInstantSearch/CustomInfiniteHits/NonEmpty";
import { GrailedAPILightListing } from "storefront/Listing/GrailedAPILightListing";
import { AlgoliaListing } from "storefront/Listing/AlgoliaListing";
import authWrapper, {
  WrappedComponentProps,
} from "storefront/components/Authentication/authWrapper";
import { ModuleType } from "storefront/Analytics/EventCreators/moduleClicked";
import Heart from "storefront/components/Icons/Heart";
import { PageType } from "storefront/Analytics/Event";
import styles from "./HeartButton.module.scss";

type OwnProps = {
  className?: string;
  listing:
    | AlgoliaInstantSearchListing
    | GrailedAPILightListing
    | AlgoliaListing;
  from: From | undefined;
  pageType: PageType | undefined;
  moduleType?: ModuleType;
  moduleName?: string;
};

type Props = WrappedComponentProps<OwnProps>;

const HeartButton = ({
  className,
  listing,
  from,
  pageType,
  authenticated,
  moduleType,
  moduleName,
}: Props) => {
  const [isFavorited, toggleIsFavorited] = useIsFavorited(
    listing,
    from,
    pageType,
    moduleType,
    moduleName,
  );

  const onClick = authenticated((user) => toggleIsFavorited(user), {
    modalTrigger: "favorite_listing",
    verifications: new Set(["email"]),
  });

  const title = isFavorited ? "Remove from Favorites" : "Add to Favorites";

  return (
    <button
      type="button"
      className={cn(styles.heartFollow, className)}
      id={`fr${listing.id}`}
      title={title}
      onClick={onClick}
    >
      <Heart isFull={isFavorited} className={styles.heart} />
    </button>
  );
};

export default authWrapper<OwnProps>(HeartButton);
